import { Products } from 'enums';

export interface Counts {
  [Products.SAIA_RECRUITING]: number;
  [Products.SAIA_SALES]: number;
  [Products.SAIA_BUNDLE]: number;
  [Products.MOTIVE]: number;
  [Products.LEAD]: number;
}

export type CountKeys = keyof Counts;

export enum BillingVariants {
  PERIOD = 'period',
  CREDITS = 'credits',
}

export enum Currencies {
  EURO = 'eur',
  US_DOLLAR = 'usd',
  GREAT_BRITISH_POUND = 'gbp',
}

export const CurrencySymbols = {
  [Currencies.EURO]: '€',
  [Currencies.US_DOLLAR]: '$',
  [Currencies.GREAT_BRITISH_POUND]: '£',
};

export enum CompanyErrors {
  COMPANY_ADDRESS_MISSING = 'company-address-missing',
  COMPANY_NAME_TOO_LONG = 'company-name-too-long',
}
